import { render } from "./ScheduledDelivery.vue?vue&type=template&id=285285bd&scoped=true"
import script from "./ScheduledDelivery.vue?vue&type=script&lang=js"
export * from "./ScheduledDelivery.vue?vue&type=script&lang=js"

import "./ScheduledDelivery.vue?vue&type=style&index=0&id=285285bd&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-285285bd"]])

export default __exports__